import { combineReducers } from 'redux';
import gettocken from './getTokenReducer';
import authReducer from './auth-reducer';

const rootReducers = combineReducers({
  gettocken,
  authReducer
});
export default rootReducers;
